import React from 'react'
import aboutImg from '../assets/Secure data-about.svg'
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';
import Link from 'react-scroll/modules/components/Link';
import Navbar from './Navbar';


function About() {
  return (
    
    
    <div name='about' className='w-full h-screen bg-white-200 flex flex-col justify-between '>
        <div className='grid md:grid-cols-2 max-w-[1240px] m-auto '>
           <div className='flex flex-col justify-center md:items-start w-full px-2 '>
           <h1 className='text-7xl font-bold'>ABOUT US</h1>
           <Bounce left>
               <h1 className='text-2xl font-bold'>Why We Care About Data</h1>
               <p className='py-3  md:text-1xl '>We believe that data generated by the people working for an organization needs to be managed.
                 Information is one of the key assets of an organization, but it is not only an asset – it is also a liability. Typically, 80% of data kept by an organisation is semi- and unstructured – information, which people work on and share with others.</p>
               <h1 className='text-2xl font-bold'>The only thing we do</h1>
               <p className='py-3  md:text-1xl '>We help organizations around the world to manage their semi- and unstructured data.
                Our singular focus is to understand the many challenges our customers are faced with when it comes to semi- and unstructured data, and to provide our standardized software and unique expertise to enterprises around the world to ensure their data is managed. We don’t do anything but this.
                 </p>

                <h1 className='text-2xl font-bold'>Solution from us we</h1>
                <p className='py-3  md:text-1xl '>Our solution to customer needs spans across the various data repositories of the customer: When the need is to manage a specific category of data, then the Data Secure Software Solution (DS) will cater for the fact that this data category will be found on file shares, in collaboration platforms as well as in mail, and these data repositories will be both on and off premise.
                 </p>

                 </Bounce>   
                 
               <button className='py-3 px-6 sm:w-[60%] my-4' >SiGN IN</button>
               
           </div>
            <div>
            <Fade right>
                <img className='w-full mt-10' src={aboutImg}alt='/'/>
            </Fade>    
            </div>
            
            
        </div>
    </div>
    
  )
}

export default About